import React from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import MainLayout from '../../components/MainLayout';
import './PlatformLayout.css';

function PlatformLayout() {
    const navigate = useNavigate();
    const location = useLocation();

    const menuItems = [
        { id: 'companies', label: '회사 관리', icon: 'business', path: '/platform/companies' },
        { id: 'users', label: '전체 사용자', icon: 'group', path: '/platform/users' },
        { id: 'status', label: '시스템 현황', icon: 'monitoring', path: '/platform/status' },
        { id: 'licenses', label: '라이선스 관리', icon: 'license', path: '/platform/licenses' }
    ];

    const isActivePath = (path) => location.pathname === path;

    return (
        <MainLayout>
            <div className="platform-container">
                {/* Left Sidebar */}
                <div className="platform-sidebar">
                    <div className="sidebar-header">
                        <h1 className="sidebar-title">플랫폼 관리</h1>
                        <p className="sidebar-subtitle">슈퍼어드민 전용</p>
                    </div>
                    <nav className="sidebar-nav">
                        {menuItems.map((item) => (
                            <div
                                key={item.id}
                                className={`nav-item ${isActivePath(item.path) ? 'active' : ''}`}
                                onClick={() => navigate(item.path)}
                            >
                                <span className="material-symbols-outlined nav-icon">{item.icon}</span>
                                <span className="nav-label">{item.label}</span>
                            </div>
                        ))}
                    </nav>
                </div>

                {/* Main Content */}
                <div className="platform-main-content">
                    <Outlet />
                </div>
            </div>
        </MainLayout>
    );
}

export default PlatformLayout;
